import SingleAccordion from 'components/SingleAccordion';
import { pushAnalyticsEvent } from 'helpers/analytics';
import { Terms, StyledContent } from './TermsAccordion.styles';

interface TermsAccordionProps {
  offerTitle: string;
  conditions: string;
}

function TermsAccordion({ conditions, offerTitle }: TermsAccordionProps) {
  const trackEvent = () => {
    pushAnalyticsEvent({ event: 'rewardViewTerms', reward: offerTitle });
    pushAnalyticsEvent({ event: 'offerViewTerms', offerTitle });
  };

  return (
    <StyledContent>
      <SingleAccordion callback={trackEvent} title="Full T&amp;Cs (the boring bits)">
        <Terms>{conditions}</Terms>
      </SingleAccordion>
    </StyledContent>
  );
}

export default TermsAccordion;
